module.exports = __webpack_public_path__ + "img/no_comment.d3396f59.png";